// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1CVD-","actions":"GroupTable_actions__3D8vP","deleteModalFooter":"GroupTable_deleteModalFooter__2H0AR"};